import React from 'react';
import { whoIWorkWith, whyWorkWithMe } from '../data/mock';

const WhoIWorkWith = ({ onContactClick }) => {
  return (
    <section style={{
      backgroundColor: '#000',
      padding: '120px 0',
      borderTop: '1px solid rgba(255,255,255,0.06)',
    }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 40px' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '80px',
        }} className="who-grid">
          {/* Who I Work With */}
          <div>
            <span style={{
              color: 'rgba(255,255,255,0.4)',
              fontFamily: "'Figtree', sans-serif",
              fontSize: '12px',
              fontWeight: '500',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              display: 'block',
              marginBottom: '20px',
            }}>Clients</span>
            <h2 style={{
              color: '#ffffff',
              fontFamily: "'Climate Crisis', sans-serif",
              fontSize: 'clamp(28px, 3.5vw, 44px)',
              fontWeight: '400',
              letterSpacing: '0em',
              lineHeight: '1.1',
              marginBottom: '48px',
            }}>
              Who I Work With
            </h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
              {whoIWorkWith.map((item, index) => (
                <div
                  key={index}
                  style={{
                    padding: '18px 0',
                    borderBottom: '1px solid rgba(255,255,255,0.06)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'default',
                    transition: 'padding-left 0.2s ease',
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.paddingLeft = '8px'}
                  onMouseLeave={(e) => e.currentTarget.style.paddingLeft = '0'}
                >
                  <span style={{
                    color: 'rgba(255,255,255,0.8)',
                    fontFamily: "'Figtree', sans-serif",
                    fontSize: '16px',
                    fontWeight: '400',
                  }}>
                    {item}
                  </span>
                  <span style={{ color: 'rgba(255,255,255,0.2)', fontSize: '20px' }}>→</span>
                </div>
              ))}
            </div>
          </div>

          {/* Why Work With Me */}
          <div>
            <span style={{
              color: 'rgba(255,255,255,0.4)',
              fontFamily: "'Figtree', sans-serif",
              fontSize: '12px',
              fontWeight: '500',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              display: 'block',
              marginBottom: '20px',
            }}>Differentiators</span>
            <h2 style={{
              color: '#ffffff',
              fontFamily: "'Climate Crisis', sans-serif",
              fontSize: 'clamp(28px, 3.5vw, 44px)',
              fontWeight: '400',
              letterSpacing: '0em',
              lineHeight: '1.1',
              marginBottom: '48px',
            }}>
              Why Work With Me
            </h2>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginBottom: '48px' }}>
              {whyWorkWithMe.map((item, index) => (
                <div key={index} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  padding: '20px 24px',
                  border: '1px solid rgba(255,255,255,0.08)',
                  borderRadius: '18px',
                  transition: 'border-color 0.2s ease, background-color 0.2s ease',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'; e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.02)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; e.currentTarget.style.backgroundColor = 'transparent'; }}
                >
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M15 4.5L7.5 12L3 7.5" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span style={{
                    color: 'rgba(255,255,255,0.8)',
                    fontFamily: "'Figtree', sans-serif",
                    fontSize: '16px',
                    fontWeight: '400',
                  }}>
                    {item}
                  </span>
                </div>
              ))}
            </div>

            <div style={{
              padding: '32px',
              border: '1px solid rgba(27,61,42,0.4)',
              borderRadius: '18px',
              backgroundColor: 'rgba(27,61,42,0.08)',
            }}>
              <p style={{
                color: 'rgba(255,255,255,0.8)',
                fontFamily: "'Figtree', sans-serif",
                fontSize: '15px',
                lineHeight: '1.8',
                marginBottom: '20px',
              }}>
                You don't hire me for inspiration.<br />
                You hire me for structure, leadership, and results.
              </p>
              <button
                onClick={onContactClick}
                style={{
                  background: '#C8102E',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '100px',
                  padding: '12px 28px',
                  fontFamily: "'Figtree', sans-serif",
                  fontSize: '13px',
                  fontWeight: '700',
                  letterSpacing: '0.04em',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s ease, transform 0.2s ease',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#a80d25'; e.currentTarget.style.transform = 'scale(1.02)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C8102E'; e.currentTarget.style.transform = 'scale(1)'; }}
              >
                Work With Me
              </button>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .who-grid {
            grid-template-columns: 1fr !important;
            gap: 60px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default WhoIWorkWith;
